import { replaceNoENtoTH } from "./ReplaceStr";
import dateFormat from "dateformat";
// var dateFormat = require('dateformat');

export const addDays = (date, days) => {
    const newDate = new Date(Number(date));
    newDate.setDate(date.getDate() + days);
    return newDate;
};

export const displayDateTH = () => {
    let th = {
        firstDayOfWeek: 1,
        numthai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
        dayNames: ["อาทิตย์", "จันทร์", "อังคาร", "พุทธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
        dayNamesShort: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        dayNamesMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        monthNames: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
        monthNamesShort: ["ม.ค.", "ก.พ.", "มี.ค", "เม.ย", "พ.ค", "มิ.ย", "ก.ค.", "ส.ค", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
        today: "Hoy",
        clear: "Limpiar",
        dateFormat: "dd/mm/yyyy",
        weekHeader: "Sm",
    };
    return th;
};

export const monthNamesTH = () => {
    const data = [
        { label: "มกราคม", value: "01" },
        { label: "กุมภาพันธ์", value: "02" },
        { label: "มีนาคม", value: "03" },
        { label: "เมษายน", value: "04" },
        { label: "พฤษภาคม", value: "05" },
        { label: "มิถุนายน", value: "06" },
        { label: "กรกฎาคม", value: "07" },
        { label: "สิงหาคม", value: "08" },
        { label: "กันยายน", value: "09" },
        { label: "ตุลาคม", value: "10" },
        { label: "พฤศจิกายน", value: "11" },
        { label: "ธันวาคม", value: "12" },
    ];
    return data;
};

export const yearTH = (start, end) => {
    //รับ start, end เข้ามาจะได้ เริ่ม -> สิ้นสุด
    const data = [];
    for (let index = start; index < end; index++) {
        data.push({ label: index.toString(), value: index });
    }
    return data;
};

export const dayTH = (month, year) => {
    //รับ month, year เข้ามาจะได้ max day เดือนนั้นออกไป
    const data = [];
    let maxDayInMonth = new Date(year, month, 0).getDate();

    for (let index = 1; index <= maxDayInMonth; index++) {
        data.push({ label: index.toString(), value: index });
    }
    return data;
};

export const formatDateTH = (date, isTime) => {
    let conv_to_date = new Date(date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear() + 543));

    let data = "";
    if (date !== undefined && date !== null) {
        if (isTime === true) {
            data = dateFormat(date_dt, "dd/mm/yyyy HH:MM");
        } else {
            data = dateFormat(date_dt, "dd/mm/yyyy");
        }
    }
    return data;
};

export const formatDateCounting = (date, isTime) => {
    let conv_to_date = new Date(date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear() + 543));

    let data = "";
    if (date !== undefined && date !== null) {
        if (isTime === true) {
            data = dateFormat(date_dt, "dd/mm/yyyy HH:MM:ss");
        } else {
            data = dateFormat(date_dt, "dd/mm/yyyy");
        }
    }
    return data;
};

export const formatDateCounting_full = (data_date, isTime) => {
    let conv_to_date = new Date(data_date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear() + 543));
    let date = dateFormat(date_dt, "dd/mm/yyyy HH:MM:ss");
    let date_time_arr = date.split(" ");
    let date_arr = [];
    let date_full = "";
    if (date_time_arr[0] !== undefined && date_time_arr[0] !== "") {
        date_arr = date_time_arr[0].split("/");

        if (isTime === true) {
            date_full = date_arr[0] + " " + replaceNoENtoTH(monthNamesTH_full(date_arr[1])) + " " + date_arr[2] + "  เวลา " + date_time_arr[1] + " น.";
        } else {
            date_full = date_arr[0] + " " + replaceNoENtoTH(monthNamesTH_full(date_arr[1])) + " " + replaceNoENtoTH(date_arr[2]);
        }
    }
    return date_full;
};

export const formatDateFull = (date, isTime) => {
    let conv_to_date = new Date(date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear()));
    let data = "";
    if (date !== undefined && date !== null) {
        if (isTime === true) {
            data = dateFormat(date_dt, "dd/mm/yyyy HH:MM");
        } else {
            data = dateFormat(date_dt, "dd/mm/yyyy");
        }
    }
    return data;
};

export const formatDateAPI = (date, isTime) => {
    let conv_to_date = new Date(date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear()));
    let data = "";
    if (date !== undefined && date !== null) {
        if (isTime === true) {
            data = dateFormat(date_dt, "yyyymmdd HH:MM");
        } else {
            data = dateFormat(date_dt, "yyyymmdd");
        }
    }
    return data;
};

export const formatDateAPI_V2 = (date, isTime) => {
    let conv_to_date = new Date(date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear()));
    let data = "";
    if (date !== undefined && date !== null) {
        if (isTime === true) {
            data = dateFormat(date_dt, "yyyy-mm-dd HH:MM");
        } else {
            data = dateFormat(date_dt, "yyyy-mm-dd");
        }
    }
    return data;
};

export const formatDateToken = (date, isTime) => {
    let conv_to_date = new Date(date);
    // let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear()));
    let data = "";
    if (date !== undefined && date !== null) {
        if (isTime === true) {
            data = dateFormat(conv_to_date, "yyyy-mm-dd HH:mm:ss.sssZ");
        } else {
            data = dateFormat(conv_to_date, "yyyy-mm-dd");
        }
    }
    return data;
};

export const formatDateFile = (date, isTime) => {
    let conv_to_date = new Date(date);
    // let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear()));
    let data = "";
    if (date !== undefined && date !== null) {
        if (isTime === true) {
            data = dateFormat(conv_to_date, "yyyymmddHHmmss");
        } else {
            data = dateFormat(conv_to_date, "yyyymmdd");
        }
    }
    return data;
};

export const monthNamesTH_Short = (mm) => {
    const data_list = [
        { label: "ม.ค.", value: "01" },
        { label: "ก.พ.", value: "02" },
        { label: "มี.ค.", value: "03" },
        { label: "เม.ย.", value: "04" },
        { label: "พ.ค.", value: "05" },
        { label: "มิ.ย.", value: "06" },
        { label: "ก.ค.", value: "07" },
        { label: "ส.ค.", value: "08" },
        { label: "ก.ย.", value: "09" },
        { label: "ต.ค.", value: "10" },
        { label: "พ.ย.", value: "11" },
        { label: "ธ.ค.", value: "12" },
    ];

    let data = data_list.filter((y) => y.value === mm);

    return data[0].label;
};

export const monthNamesTH_full = (mm) => {
    const data_list = [
        { label: "มกราคม", value: "01" },
        { label: "กุมภาพันธ์", value: "02" },
        { label: "มีนาคม", value: "03" },
        { label: "เมษายน", value: "04" },
        { label: "พฤษภาคม", value: "05" },
        { label: "มิถุนายน", value: "06" },
        { label: "กรกฎาคม", value: "07" },
        { label: "สิงหาคม", value: "08" },
        { label: "กันยายน", value: "09" },
        { label: "ตุลาคม", value: "10" },
        { label: "พฤศจิกายน", value: "11" },
        { label: "ธันวาคม", value: "12" },
    ];

    let data = data_list.filter((y) => y.value === mm);

    return data[0].label;
};

export const formatDateTH_full = (data_date, isTime) => {
    let conv_to_date = new Date(data_date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear()));
    let date = dateFormat(date_dt, "dd/mm/yyyy HH:MM");
    let date_time_arr = date.split(" ");
    let date_arr = [];
    let date_full = "";
    if (date_time_arr[0] !== undefined && date_time_arr[0] !== "") {
        date_arr = date_time_arr[0].split("/");

        if (isTime === true) {
            date_full = "วันที่ " + replaceNoENtoTH(date_arr[0]) + " " + replaceNoENtoTH(monthNamesTH_full(date_arr[1])) + " " + replaceNoENtoTH(date_arr[2]) + "  เวลา " + replaceNoENtoTH(date_time_arr[1]) + " นาฬิกา";
        } else {
            date_full = "วันที่ " + replaceNoENtoTH(date_arr[0]) + " " + replaceNoENtoTH(monthNamesTH_full(date_arr[1])) + " " + replaceNoENtoTH(date_arr[2]);
        }
    }
    return date_full;
};

export const formatDateTH_full2 = (data_date, isTime) => {
    let conv_to_date = new Date(data_date);
    let date_dt = new Date(conv_to_date.setFullYear(conv_to_date.getFullYear() + 543));
    let date = dateFormat(date_dt, "dd/mm/yyyy HH:MM");
    let date_time_arr = date.split(" ");
    let date_arr = [];
    let date_full = "";
    if (date_time_arr[0] !== undefined && date_time_arr[0] !== "") {
        date_arr = date_time_arr[0].split("/");

        if (isTime === true) {
            date_full = "วันที่ " + replaceNoENtoTH(date_arr[0]) + " " + replaceNoENtoTH(monthNamesTH_full(date_arr[1])) + " " + replaceNoENtoTH(date_arr[2]) + "  เวลา " + replaceNoENtoTH(date_time_arr[1]) + " น.";
        } else {
            date_full = "วันที่ " + replaceNoENtoTH(date_arr[0]) + " " + replaceNoENtoTH(monthNamesTH_full(date_arr[1])) + " " + replaceNoENtoTH(date_arr[2]);
        }
    }
    return date_full;
};

export const formatDateNum_TH = (date) => {
    let mm, yyyy;
    if (date && date.length === 8) {
        // yyyy = replaceNoENtoTH(new Date(date.substr(0,4)).getFullYear()+543)
        yyyy = new Date(date.substr(0, 4)).getFullYear() + 543;
        mm = monthNamesTH_Short(date.substr(4, 2));
        // dd = date.substr(6,2);
        // newdate = dd+" "+mm+" "+yyyy
        // console.log('new date ', dd,mm,yyyy );
        date = mm + " " + yyyy;
    }

    return date;
};

// dd/mm/yyyy TH
export const formatDateConvert = (date = "") => {
    const _date = date.split(" ")[0];
    const _time = date.split(" ")[1];
    const dd = "" + _date.split("/")[0],
        mm = "" + _date.split("/")[1],
        yyyy = _date.split("/")[2] - 543;

    const fullDate = [yyyy, mm, dd].join("-") + " " + _time;

    return fullDate;
};

export const formatDateConvert_th = (date) => {
    const dd = "" + date.split("/")[0],
        mm = "" + date.split("/")[1];
    const yyyy = parseInt(date.split("/")[2]) + 543;

    const fullDate = [yyyy, mm, dd].join("-");

    return fullDate;
};

export const formatDateConvert_2 = (date) => {
    const dd = "" + date.split("/")[0],
        mm = "" + date.split("/")[1],
        yyyy = date.split("/")[2] - 543;

    const fullDate = [yyyy, mm, dd].join("-");

    return fullDate;
};

export const dateTh = (_date) => {
    const d = new Date(_date);
    let month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear() + 543;
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("/");
};
